import { render, staticRenderFns } from "./right-top.vue?vue&type=template&id=a50dbd74&scoped=true"
import script from "./right-top.vue?vue&type=script&lang=js"
export * from "./right-top.vue?vue&type=script&lang=js"
import style0 from "./right-top.vue?vue&type=style&index=0&id=a50dbd74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50dbd74",
  null
  
)

export default component.exports